import { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import {
  useFetchAllBikajiShelfMutation,
  useUpdateShelfStatusBikajiMutation,
  useDetectShelfProductsMutation,
} from "../../../features/tenant/Bikaji/BikajiApi";
import { getVendorName } from "../../../utils/getVendorName";
import toast from "react-hot-toast";
import { TiTick, TiTimes } from "react-icons/ti";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import view from "../../../assests/tenant/images/view.svg";

const BikajiIShelfList = () => {
  const navigate = useNavigate();
  const [tableDataItems, setTableDataItems] = useState([]);
  const [myList, setMyList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [showImage, setShowImage] = useState("");
  const [image, setImage] = useState("");

  // Detection modal states
  const [showDetectModal, setShowDetectModal] = useState(false);
  const [detectData, setDetectData] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const initialRequest = {
    limit: 10,
    offset: 0,
    mobile: "",
    startDate: "",
    endDate: "",
  };
  const [request, setRequest] = useState(initialRequest);

  const clearFilters = () => {
    setRequest(initialRequest);
    handleBikajiOrdersList(initialRequest);
  };

  const [
    fetchAllBikajiOrders,
    {
      data: fetchAllBikajiOrdersData,
      error: fetchAllBikajiOrdersError,
      isLoading: fetchAllBikajiOrdersisLoading,
    },
  ] = useFetchAllBikajiShelfMutation();

  const [
    fetchAllBikajiOrdersCSV,
    {
      data: fetchAllBikajiOrdersCSVData,
      error: fetchAllBikajiOrdersCSVError,
    },
  ] = useFetchAllBikajiShelfMutation();

  const [
    handleAcceptRequest,
    { data: handleAcceptRequestData, error: handleAcceptRequestError },
  ] = useUpdateShelfStatusBikajiMutation();

  const [
    handleRejectRequest,
    { data: handleRejectRequestData, error: handleRejectRequestError },
  ] = useUpdateShelfStatusBikajiMutation();

  // New detection API mutation
  const [
    detectShelfProducts,
    {
      data: detectShelfData,
      error: detectShelfError,
      isLoading: detectShelfLoading,
    },
  ] = useDetectShelfProductsMutation();

  const handleBikajiOrdersList = (orderRequest = request) => {
    fetchAllBikajiOrders({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: orderRequest,
    });
  };

  const handleBikajiOrdersListCSV = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    fetchAllBikajiOrdersCSV({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: modifiedRequest,
    });
  };

  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (fetchAllBikajiOrdersCSVData && fetchAllBikajiOrdersCSVData?.body?.shelf) {
      setCsvData(fetchAllBikajiOrdersCSVData?.body?.shelf);
    }

    if (fetchAllBikajiOrdersCSVError) {
      setCsvData(null);
    }
  }, [fetchAllBikajiOrdersCSVData, fetchAllBikajiOrdersCSVError]);

  useEffect(() => {
    handleBikajiOrdersList();
  }, [limit, offset]);

  useEffect(() => {
    if (fetchAllBikajiOrdersData && fetchAllBikajiOrdersData.body) {
      toast.dismiss();
      toast.success(`${fetchAllBikajiOrdersData.message}`, {
        id: "fetchAllBikajiOrdersData",
      });
      const arr = [...fetchAllBikajiOrdersData.body.shelf];
      setTableDataItems(arr);

      setTotalRows(
        fetchAllBikajiOrdersData &&
          fetchAllBikajiOrdersData.body.total_shelf
          ? fetchAllBikajiOrdersData.body.total_shelf
          : 0
      );
    }

    if (fetchAllBikajiOrdersError) {
      toast.dismiss();
      toast.error(`${fetchAllBikajiOrdersError.data.message}`, {
        id: "fetchAllBikajiOrdersError",
      });
    }
  }, [fetchAllBikajiOrdersData, fetchAllBikajiOrdersError]);

  const handleApprove = (e, row) => {
    let amount = window.prompt("Please enter points (numbers only)");

    if (amount !== null) {
      amount = amount.trim();

      if (!/^\d+(\.\d+)?$/.test(amount)) {
        alert("❌ Please enter a valid number");
        return;
      }

      const numericAmount = Number(amount);

      handleAcceptRequest({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: {
          id: row.id,
          status: "1",
          points: numericAmount,
        },
      });
    }
  };

  useEffect(() => {
    if (handleAcceptRequestData) {
      toast.dismiss();
      toast.success(`${handleAcceptRequestData.message}`, {
        id: "handleAcceptRequestData",
      });
      handleBikajiOrdersList();
    }

    if (handleAcceptRequestError) {
      toast.dismiss();
      toast.error(`${handleAcceptRequestError.data.message}`, {
        id: "handleAcceptRequestError",
      });
    }
  }, [handleAcceptRequestData, handleAcceptRequestError]);

  const handleReject = (e, row) => {
    let reason = "";

    while (!reason || reason.trim() === "") {
      reason = window.prompt("Please enter reason");

      if (reason === null) {
        return;
      }
    }
    handleRejectRequest({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        id: row.id,
        status: "2",
        remark: reason,
      },
    });
  };

  useEffect(() => {
    if (handleRejectRequestData) {
      toast.dismiss();
      toast.success(`${handleRejectRequestData.message}`, {
        id: "handleRejectRequestData",
      });
      handleBikajiOrdersList();
    }

    if (handleRejectRequestError) {
      toast.dismiss();
      toast.error(`${handleRejectRequestError.data.message}`, {
        id: "handleAcceptRequestError",
      });
    }
  }, [handleRejectRequestData, handleRejectRequestError]);

  const handleProductImage = (row) => {
    setShowImage(!showImage);
    setImage(row?.image || "");
  };

  //  Detect handler
  const handleDetect = async (row) => {
    setSelectedRow(row);
    setShowDetectModal(true);
    setDetectData(null);
    detectShelfProducts({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: { image_url: row.image },
    });
  };

  useEffect(() => {
    if (detectShelfData) {
      toast.success("Detection completed successfully!");
      setDetectData(detectShelfData.body);
    }
    if (detectShelfError) {
      toast.error("Detection failed. Please try again.");
    }
  }, [detectShelfData, detectShelfError]);

  const columns = [
    {
      name: "S.No",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row.buyer_name,
    },
    {
      name: "Mobile  ",
      selector: (row) => row.buyer_mobile,
    },
    {
      name: "User Type",
      selector: (row) => row.buyer_user_type,
    },
    {
      name: "Points",
      selector: (row) => row.points,
    },
    {
      name: "Remarks  ",
      selector: (row) => row.remark,
    },
    {
      name: "State ",
      selector: (row) => row.buyer_state,
    },
    {
      name: "District ",
      selector: (row) => row.buyer_district,
    },
    {
      name: "city",
      selector: (row) => row.buyer_city,
    },
    {
      name: "Image",
      width: "150px",
      cell: (row) => {
        if (!row.image) return <></>;
        return (
          <>
            <button type="button" className="bg-black p-1 rounded-sm">
              <img src={view} alt="" onClick={() => handleProductImage(row)} />
            </button>
          </>
        );
      },
    },
    {
      name: "Request Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
      width: "170px",
    },
    {
      name: "Action Taken At",
      selector: (row) =>
        ["1", "2"].includes(row.status)
          ? new Date(row.line_updated_at).toLocaleString()
          : "",
      sortable: true,
      width: "170px",
    },

    //  Updated Action column
    {
      name: "",
      cell: (row) => (
        <div>
          {row.status == "0" && (
            <div className="flex space-x-1">
              <button
                onClick={() => handleDetect(row)}
                className="flex justify-center items-center rounded bg-blue-600 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-lg transition duration-150 ease-in-out hover:bg-blue-700"
              >
                Detect
              </button>
              <button
                onClick={(e) => handleApprove(e, row)}
                className="flex justify-center items-center rounded bg-success px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#14a44d] transition duration-150 ease-in-out hover:bg-success-600 focus:bg-success-600 active:bg-success-700"
              >
                <TiTick className="mr-1" />
                Approve
              </button>
              <button
                onClick={(e) => handleReject(e, row)}
                className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-lg transition duration-150 ease-in-out hover:bg-danger-600 focus:bg-danger-600 active:bg-danger-700"
              >
                <TiTimes className="mr-1" />
                Reject
              </button>
            </div>
          )}
          {row.status == "2" && <div className="text-red-950">Rejected</div>}
          {row.status == "1" && <div className="text-green-600">Approved</div>}
        </div>
      ),
      width: "280px",
    },
  ];

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Order Requests List
            <LinksComponent />
          </div>

          <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
            <div className="flex justify-between items-start">
              <div className="mb-2">
                <CustomExport
                  fetchData={() => {
                    handleBikajiOrdersListCSV();
                  }}
                  data={csvData}
                  defaultColumnExport={[]}
                  filename="cash_transfer_request_list"
                />
              </div>
            </div>
            <div className="flex  space-x-2 ">
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Mobile No
                  </label>
                  <input
                    type="search"
                    id="default-search"
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="Mobile..."
                    required
                    value={request.mobile}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return { ...prevState, mobile: newValue };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    id="default-search"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="Start Date"
                    value={request.startDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          startDate: newValue,
                        };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    id="default-search"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="End Date"
                    value={request.endDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          endDate: newValue,
                        };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="">
                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                  &nbsp;
                </label>

                <div className="flex flex-row  gap-2 ">
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        handleBikajiOrdersList();
                      }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                      onClick={() => {
                        clearFilters();
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3">
            {fetchAllBikajiOrdersisLoading && <CircleLoaderComponent />}
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={tableDataItems}
                totalRows={
                  fetchAllBikajiOrdersData &&
                  fetchAllBikajiOrdersData?.body?.total_shelf
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
            </div>
          </div>

          {showImage && (
            <ImageModal
              show={showImage}
              setShow={setShowImage}
              size="md"
              data={image}
            >
              <div className="w-[400px] h-[400px] overflow-hidden rounded-lg bg-gray-200">
                <img
                  src={image}
                  alt="product-image"
                  className="w-full h-full object-contain"
                />
              </div>
            </ImageModal>
          )}

          {/*  Detect Modal */}
          {showDetectModal && (
            <ImageModal
              show={showDetectModal}
              setShow={setShowDetectModal}
              size="xl"
              data={detectData}
            >
              <div className="w-[800px] h-[500px] overflow-y-auto bg-white p-4 rounded-lg">
                {detectShelfLoading && <CircleLoaderComponent />}

                {!detectShelfLoading && detectData && (
                  <>
                    <div className="flex justify-between mb-3">
                      <div>
                        <h3 className="font-semibold text-lg">
                          Original Image
                        </h3>
                        <img
                          src={selectedRow?.image}
                          alt="original"
                          className="w-[350px] h-[350px] object-contain border rounded"
                        />
                      </div>
                      <div>
                        <h3 className="font-semibold text-lg">Detected Image</h3>
                        <img
                          src={detectData?.detected_image}
                          alt="detected"
                          className="w-[350px] h-[350px] object-contain border rounded"
                        />
                      </div>
                    </div>
                    <div className="text-center font-medium mb-4">
                      Total Bikaji Products Detected:{" "}
                      <span className="font-bold text-blue-700">
                        {detectData?.total_detected || 0}
                      </span>
                    </div>
                    <div className="flex justify-center gap-3">
                      <button
                        onClick={(e) => handleApprove(e, selectedRow)}
                        className="bg-green-600 px-4 py-2 rounded text-white"
                      >
                        Approve
                      </button>
                      <button
                        onClick={(e) => handleReject(e, selectedRow)}
                        className="bg-red-600 px-4 py-2 rounded text-white"
                      >
                        Reject
                      </button>
                    </div>
                  </>
                )}
              </div>
            </ImageModal>
          )}
        </div>
      </div>
    </>
  );
};

export default BikajiIShelfList;